/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Col,
  Typography,
  Form,
  Row,
  Input,
  Button,
  message,
  Spin,
  Table,
  Tooltip,
  DatePicker,
  notification,
  Select,
  InputNumber,
  Upload,
} from 'antd';
import {
  FilePdfOutlined,
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  PlusOutlined,
  MessageOutlined,
  CloudUploadOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import get from 'lodash/get';
import { Package, MessageSquare } from 'lucide-react';
const { Title, Text } = Typography;
import {
  fetchToolBoxList,
  addToolBox,
  updateToolBox,
  deleteToolBox,
  deleteToolBoxListFile,
} from '../redux/toolboxAdmin/action';
import { connect } from 'react-redux';
const ToolboxAdmin = (props) => {
  const {
    toolboxList,
    istoolboxListLoading,
    onFetchToolBoxList,
    onAddToolBox,
    onUpdateToolBox,
    onDeleteToolBox,
    onDeleteToolBoxListFile,
  } = props;

  const { Option } = Select;
  // const { Column, ColumnGroup } = Table;
  let s3Bucketname;
  if (process.env.REACT_APP_STAGE == 'dev') {
    s3Bucketname = 'pih-dev-server-bucket';
  }
  if (process.env.REACT_APP_STAGE == 'staging') {
    s3Bucketname = 'pih-staging-server-bucket';
  }
  if (process.env.REACT_APP_STAGE == 'prod') {
    s3Bucketname = 'pih-production-server-bucket';
  }

  const [tagTitle, setTagTitle] = useState('');
  const [tagPrepopulatedDiscussion, setTagPrepopulatedDiscussion] = useState('');
  const [createdBy, setCreatedBy] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');
  //
  const { Title } = Typography;
  const { TextArea } = Input;
  //
  const [toolboxlist, setToolboxlist] = useState([]);
  const [toolboxListModalVisible, setToolboxListModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();
  const [filteredList, setFilteredList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [isEditTitle, setIsEditTitle] = useState(false);
  const [updateTagTitle, setUpdateTagTitle] = useState('');
  const [editListId, setEditListId] = useState('');
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [selectedPdfListTitle, setSelectedPdfListTitle] = useState('');
  const [pdfList, setPdfList] = useState([]);
  const [fileVersion, setFileVersion] = useState();
  const [pdfListVal, setPdfListVal] = useState([]);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [tagTitleSearch, setTagTitleSearch] = useState('');
  const [communicationTypeSearch, setCommunicationTypeSearch] = useState('');
  const [tagPrepopulatedDiscussionSearch, setTagPrepopulatedDiscussionSearch] = useState('');
  const [createdBySearch, setCreatedBySearch] = useState('');
  const [createdAtSearch, setCreatedAtSearch] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  let name;
  if (user.name) {
    name = user.name;
  } else {
    name = user['custom:first_name'] + ' ' + user['custom:last_name'];
  }

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString();

  form.setFieldsValue({
    createdBy: name,
    createdAt: moment(formattedDate),
  });

  const communicationTypes = [
    { code: 'SA', label: 'Safety Alert' },
    { code: 'TB', label: 'Toolbox Talk' },
    { code: 'EN', label: 'Engineering Notification' },
    { code: 'QA', label: 'Quality Alert' },
    { code: 'EA', label: 'Environmental Alert' },
    { code: 'RA', label: 'Risk Assessments' },
  ];

  const ExpandableDescription = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const shouldShowButton = text && text.length > 100;

    return (
      <div style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
        {isExpanded ? text : (text ? text.slice(0, 100) + (shouldShowButton ? '...' : '') : '')}
        {shouldShowButton && (
          <Button
            type="link"
            onClick={() => setIsExpanded(!isExpanded)}
            style={{ padding: 0, height: 'auto', marginLeft: '4px', fontSize: '12px', color: '#1890ff' }}
          >
            {isExpanded ? 'Read less' : 'Read more'}
          </Button>
        )}
      </div>
    );
  };

  const renderColumnTitle = (title, setter) => (
    <div className="column-header-with-filter">
      <div className="column-header-text-wrapper">
        <span>{title}</span>
      </div>
      <div className="header-filter-input">
        <Input
          placeholder="Search"
          onChange={(e) => {
            const value = e.target.value;
            setter(value);
          }}
          allowClear
          onClick={(e) => e.stopPropagation()}
          size="small"
        />
      </div>
    </div>
  );
  //Table column
  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
      align: 'center',
      width: '60px',
      render: (text, record, index) => index + 1,
    },
    {
      title: renderColumnTitle('Title', setTagTitleSearch),
      dataIndex: 'tagTitle',
      key: 'tagTitle',
      align: 'left',
      width: '200px',
    },
    {
      title: renderColumnTitle('Type', setCommunicationTypeSearch),
      dataIndex: 'communicationType',
      key: 'communicationType',
      align: 'left',
      width: '150px',
      render: (data) => {
        const foundType = communicationTypes.find((type) => type.code === data);
        return foundType ? foundType.label : data;
      },
    },
    {
      title: renderColumnTitle('Description', setTagPrepopulatedDiscussionSearch),
      dataIndex: 'tagPrepopulatedDiscussion',
      key: 'tagPrepopulatedDiscussion',
      align: 'left',
      width: '400px',
      render: (data) => <ExpandableDescription text={data} />,
    },
    {
      title: renderColumnTitle('Created By', setCreatedBySearch),
      dataIndex: 'createdBy',
      key: 'createdBy',
      align: 'left',
      width: '150px',
    },
    {
      title: (
        <div className="column-header-with-filter">
          <div className="column-header-text-wrapper">
            <span>Created Date</span>
          </div>
          <div className="header-filter-input">
            <DatePicker
              placeholder="Filter Date"
              onChange={(date) => setCreatedAtSearch(date)}
              allowClear
              onClick={(e) => e.stopPropagation()}
              size="small"
              format="DD-MMM-YYYY"
              style={{ width: '100%' }}
            />
          </div>
        </div>
      ),
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'center',
      width: '140px',
      render: (text) => moment(text).format('DD-MMM-YYYY'),
    },
    {
      title: 'Attachement',
      dataIndex: 'actions',
      key: 'actions',
      align: 'center',
      width: '90px',
      render: (text, record) => (
        <div>
          {record.crdmFiles.length > 1 ? (
            <Tooltip title="View File">
              <Button
                onClick={() => handlePdfModal(record)}
                className="p-0 pdfIcon border-0"
                size="small"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FilePdfOutlined className="txtIcon" style={{ color: '#ef314c !important', fontSize: '18px !important' }} />
              </Button>
            </Tooltip>
          ) : record.crdmFiles[0]?.fileKey ? (
            <Tooltip title="View File">
              <Button
                href={`https://${s3Bucketname}.s3.us-west-2.amazonaws.com/${record.crdmFiles[0]?.fileKey}`}
                className="p-0 pdfIcon border-0"
                size="small"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FilePdfOutlined className="txtIcon" style={{ color: '#ef314c !important', fontSize: '18px !important' }} />
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title="Report Not Generated">
              <span className="icon-24 mr-2 cursor-pointer edit-hover">
                <FilePdfOutlined className="txtIcon" style={{ color: '#d1d5db !important', cursor: 'not-allowed', fontSize: '18px !important' }} />
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'actions',
      key: 'actions',
      align: 'center',
      render: (text, record) => (
        <div className="heat-profile-actions-cell" style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Tooltip title="Edit">
            <EditOutlined
              className="txtIcon"
              style={{ fontSize: '18px !important', color: '#00A86B !important', cursor: 'pointer' }}
              onClick={() => showAddEditListModal(record, true)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined
              className="txtIcon"
              style={{ fontSize: '18px !important', color: '#ef314c !important', cursor: 'pointer' }}
              onClick={() => handleDeletion(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    onFetchToolBoxList();
  }, []);

  useEffect(() => {
    toolboxList.map((item, i) => {
      item.sno = i + 1;
      item.communication_label = communicationTypes.find(
        (type) => type.code === item.communicationType
      )?.label;
    });
    setFilteredList(toolboxList);
    setToolboxlist(toolboxList);
  }, [toolboxList]);

  //search Toolbox list by  Title
  const typeMapping = {
    SA: 'SA – Safety Alert',
    TB: 'TB – Toolbox Talk',
    EN: 'EN – Engineering Notification',
    QA: 'QA – Quality Alert',
    EA: 'EA – Environmental Alert',
    RA: 'RA – Risk Assessments',
  };

  useEffect(() => {
    const filterList = toolboxlist.filter((item) => {
      const tagTitle = item.tagTitle ? item.tagTitle.toLowerCase() : '';
      const createdBy = item.createdBy ? item.createdBy.toLowerCase() : '';
      const communicationType = item.communicationType
        ? typeMapping[item.communicationType].toLowerCase()
        : '';
      const tagPrepopulatedDiscussion = item.tagPrepopulatedDiscussion
        ? item.tagPrepopulatedDiscussion.toLowerCase()
        : '';

      const matchesTagTitle = tagTitle.includes(tagTitleSearch.toLowerCase());
      const matchesCreatedBy = createdBy.includes(createdBySearch.toLowerCase());
      const matchesCommunicationType = communicationType.includes(communicationTypeSearch.toLowerCase());
      const matchesDescription = tagPrepopulatedDiscussion.includes(
        tagPrepopulatedDiscussionSearch.toLowerCase()
      );

      const matchesDate = !createdAtSearch || (item.createdAt && moment(item.createdAt).isSame(createdAtSearch, 'day'));

      return (
        matchesTagTitle &&
        matchesCreatedBy &&
        matchesCommunicationType &&
        matchesDescription &&
        matchesDate
      );
    });
    setFilteredList(filterList);
    setCurrent(1);
  }, [
    tagTitleSearch,
    communicationTypeSearch,
    tagPrepopulatedDiscussionSearch,
    createdBySearch,
    createdAtSearch,
    toolboxlist,
  ]);

  //Edit toolbox list data
  const showAddEditListModal = async (record, edit) => {
    let userDt = {};
    if (record !== '') {
      userDt.tagTitle = record.tagTitle;
      userDt.communicationType = record.communicationType;
      userDt.createdBy = record.createdBy;
      userDt.tagPrepopulatedDiscussion = record.tagPrepopulatedDiscussion;
      userDt.createdAt = moment(formattedDate);

      form.setFieldsValue(userDt);
      setTagTitle(record.tagTitle);
      setUpdateTagTitle(record.tagTitle);
      setEditListId(record.id);
      setPdfList(record.crdmFiles);
      setPdfListVal(record.crdmFiles);
      setFileVersion(record.crdmFiles[record.crdmFiles.length - 1]?.fileVersion);
    }
    setIsEdit(edit);
    setDisableFileUpload(false);
    setToolboxListModalVisible(true);
  };

  //Add and Update new data in List
  const handleOk = () => {
    let payload = {};
    form.validateFields().then((data) => {
      if (
        data.tagTitle.trim() &&
        data.communicationType &&
        data.tagPrepopulatedDiscussion.trim() &&
        data.createdBy.trim()
      ) {
        // if (isEdit && pdfList.length == 0) {
        if (isEdit) {
          if (pdfListVal.length !== 0) {
            payload = {
              tagTitle: data.tagTitle,
              communicationType: data.communicationType,
              tagPrepopulatedDiscussion: data.tagPrepopulatedDiscussion,
              createdBy: data.createdBy,
              crdmFiles: fileList,
              id: editListId,
            };
            let fileV = parseInt(fileVersion);
            if (!isNaN(fileV)) {
              fileV = fileV + 1;
            } else {
              fileV = 1;
            }
            onUpdateToolBox({ data: payload, id: editListId, fileVersion: fileV });
            resetFields();
          } else {
            showNotification();
          }
        } else if (fileList.length) {
          payload = {
            tagTitle: data.tagTitle,
            communicationType: data.communicationType,
            tagPrepopulatedDiscussion: data.tagPrepopulatedDiscussion,
            createdBy: data.createdBy,
            crdmFiles: fileList,
          };
          onAddToolBox(payload);
          resetFields();
        } else {
          showNotification();
        }
      } else {
        showNotification();
      }
    });
  };

  const showNotification = () => {
    notification.warning({
      message: 'Fill all the required fields!',
    });
  };

  const resetFields = () => {
    setTimeout(() => {
      setToolboxListModalVisible(false);
      form.resetFields();
      setFileList([]);
      setPdfListVal([]);
      setDisableFileUpload(false);
      setIsEdit(false);
    }, 1000);
  };

  //Delete List data
  const handleDeletion = (record) => {
    setItemToDelete(record);
    setIsDeleteModalVisible(true);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    setIsDeleting(true);
    try {
      await onDeleteToolBox({ id: itemToDelete.id });
      setIsDeleteModalVisible(false);
      setItemToDelete(null);
    } catch (error) {
      console.error('Error deleting data:', error);
      message.error('Data delete failed.');
    } finally {
      setIsDeleting(false);
    }
  };

  const deleteToolListFile = (id) => {
    Modal.confirm({
      className: 'custom-text-clr',
      title: 'Are you sure you want to delete this file?',
      async onOk() {
        try {
          onDeleteToolBoxListFile({ id: id });
          const updatedPdfList = pdfList.filter((pdf) => pdf.id !== id);
          setPdfList(updatedPdfList);
          setPdfListVal(updatedPdfList);
        } catch (error) {
          console.error('Error deleting data:', error);
          message.error('File delete failed.');
          throw error;
        }
      },
      onCancel() { },
    });
  };

  const filePropsForOne = {
    onRemove: () => {
      setFileList([]);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      const normalizedName =
        file.name
          .trim()
          .replace(/[\r\n]+/g, ' ')
          .replace(/\s+/g, ' ')
          .replace(/^\s+|\s+$/g, '') || file.name;
      const normalizedFile = new File([file], normalizedName, { type: file.type });
      setFileList([normalizedFile]);
      setPdfListVal([normalizedFile]);
      setDisableFileUpload(true);
      return false;
    },
    fileList,
  };

  const handlePdfModal = (record) => {
    setSelectedPdfListTitle(record.tagTitle);
    setPdfList(record.crdmFiles);
    setPdfListVal(record.crdmFiles);
    setPdfModalVisible(true);
  };

  const pdfModalCancel = () => {
    setPdfModalVisible(false);
    setSelectedPdfListTitle('');
    setPdfList([]);
    setPdfListVal([]);
  };

  const handleEdit = () => {
    setIsEdit(true);
  };

  const handleCancel = () => {
    setIsEdit(false);
    form.resetFields();
    setToolboxListModalVisible(false);
    setTagTitle('');
    setUpdateTagTitle('');
    setEditListId('');
    setPdfList([]);
    setPdfListVal([]);
    setFileVersion();
    setFileList([]);
    setDisableFileUpload(false);
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  return (
    <>
      <div className="heat-profile-content-wrapper">
        <div className="heat-profile-card">
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <MessageSquare size={22} />
              </div>
              <div className="heat-profile-header-content">
                <div className="heat-profile-title-row">
                  <h3 className="heat-profile-list-title">List of Communications</h3>
                </div>
                <p className="heat-profile-list-description">
                  Manage safety alerts, toolbox talks, engineering notifications, and more.
                </p>
              </div>
            </div>

            <div className="heat-profile-header-actions">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  form.resetFields();
                  setFileList([]);
                  setPdfListVal([]);
                  setIsEdit(false);
                  setToolboxListModalVisible(true);
                  form.setFieldsValue({
                    createdBy: name,
                    createdAt: moment(formattedDate),
                  });
                }}
                className="heat-profile-add-btn"
              >
                Create New Communication
              </Button>
            </div>
          </div>
          <div className="heat-profile-table-wrap" style={{ marginTop: '0px' }}>
            <Table
              className="heat-profile-table"
              columns={columns}
              dataSource={filteredList}
              loading={istoolboxListLoading}
              rowKey="id"
              pagination={{
                current: current,
                pageSize: pageSize,
                total: filteredList.length,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page, size) => {
                  setCurrent(page);
                  setPageSize(size);
                },
              }}
              scroll={{ x: 'max-content' }}
            />
          </div>
        </div>
      </div>
      {toolboxListModalVisible ? (
        <Modal
          width={700}
          className="heatprofile-modal"
          centered
          title={isEdit ? 'Edit Communication' : 'Create New Communication'}
          open={toolboxListModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={handleOk}
              loading={istoolboxListLoading}
            >
              {isEdit ? 'Update' : 'Create'}
            </Button>,
          ]}
        >
          {/* <Spin spinning={loading} tip="Wait: PDF is being generated and uploaded..."> */}
          <Form name="basic" layout="vertical" autoComplete="off" getcontainer={false} form={form}>
            <Row gutter={12} className="upload-row">
              <Col lg={12}>
                <Form.Item label="Title" name="tagTitle" required>
                  <Input
                    value={tagTitle}
                    onChange={(e) => setTagTitle(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item label="Type" name="communicationType" required>
                  <Select
                    className="client-select"
                    placeholder="Select Type"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    // value={communicationType}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    <Option value="SA">SA – Safety Alert</Option>
                    <Option value="TB">TB – Toolbox Talk</Option>
                    <Option value="EN">EN – Engineering Notification</Option>
                    <Option value="QA">QA – Quality Alert</Option>
                    <Option value="EA">EA – Environmental Alert</Option>
                    <Option value="RA">RA – Risk Assessments</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={24}>
                <Form.Item label="Description" name="tagPrepopulatedDiscussion" required>
                  <TextArea
                    value={tagPrepopulatedDiscussion}
                    onChange={(e) => setTagPrepopulatedDiscussion(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item label="Created By" name="createdBy" required>
                  <Input
                    value={name}
                    onChange={(e) => setCreatedBy(e.target.value)}
                    size="large"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  className="date-picker"
                  label={isEdit ? 'Updated Date' : 'Created Date'}
                  name="createdAt"
                  required
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    value={createdAt ? moment(createdAt) : null}
                    onChange={(date, dateString) => setCreatedAt(dateString)}
                    size="large"
                    format="DD-MMM-YYYY"
                    disabledDate={disabledDate}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col lg={24}>
                <div className="uploadFile_admin">
                  <Form.Item label="Attachment" name="file" required>
                    <Upload
                      {...filePropsForOne}
                      maxCount={1}
                      className="upload-full-width"
                      accept=".pdf,.txt,.doc,.pptx"
                      showUploadList={false}
                    >
                      <div className="premium-upload-trigger">
                        <CloudUploadOutlined className="upload-icon" />
                        <div className="upload-text">
                          <span className="main-text">Click to Select Attachment</span>
                          <span className="sub-text">Support for .pdf, .txt, .doc, .pptx files</span>
                        </div>
                      </div>
                    </Upload>
                  </Form.Item>
                </div>
              </Col>
              {isEdit && (
                <div>
                  {pdfList.map((pdf, index) => (
                    <div key={index} className="pdf-row toolbox-pdf">
                      <p className="selectTxtFile">
                        {pdf.fileName}
                        {' - '}Version {pdf.fileVersion}
                      </p>

                      <div className="pdf-row_button">
                        <Button
                          className="rowPdfIcon"
                          href={`https://${s3Bucketname}.s3.us-west-2.amazonaws.com/${pdf.fileKey}`}
                          icon={<FilePdfOutlined className="IconRed" />}
                          style={{ marginRight: '8px' }}
                        ></Button>
                        <Button
                          className="rowPdfIcon"
                          onClick={() => deleteToolListFile(pdf.id)}
                          icon={<DeleteOutlined className="txtIcon" />}
                        ></Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Row>
          </Form>
        </Modal>
      ) : null}
      {pdfModalVisible ? (
        <Modal
          width={500}
          className="heatprofile-modal"
          title={`${selectedPdfListTitle} - Available Documents`}
          centered
          visible={pdfModalVisible}
          footer={[
            <Button key="submit1" type="primary" onClick={pdfModalCancel}>
              Cancel
            </Button>,
          ]}
        >
          <div>
            {pdfList.map((pdf, index) => (
              <div key={index} className="pdf-row toolbox-pdf">
                <p className="selectTxtFile" style={{ marginRight: '8px' }}>
                  {pdf.fileName}
                  {' - '}Version {pdf.fileVersion}
                </p>
                <div className="pdf-row_button">
                  <Button
                    className="rowPdfIcon"
                    href={`https://${s3Bucketname}.s3.us-west-2.amazonaws.com/${pdf.fileKey}`}
                    icon={<FilePdfOutlined className="IconRed" />}
                    style={{ marginRight: '8px' }}
                  ></Button>
                  <Button
                    className="rowPdfIcon"
                    onClick={() => deleteToolListFile(pdf.id)}
                    icon={<DeleteOutlined className="txtIcon" />}
                  ></Button>
                </div>
              </div>
            ))}
          </div>
        </Modal>
      ) : null}
      {isDeleteModalVisible ? (
        <Modal
          width={500}
          className="heatprofile-modal"
          title={<span style={{ fontWeight: 'bold', color: '#000' }}>Delete Communication</span>}
          centered
          open={isDeleteModalVisible}
          onCancel={() => setIsDeleteModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsDeleteModalVisible(false)}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              danger
              onClick={confirmDelete}
              loading={isDeleting}
            >
              Confirm Delete
            </Button>,
          ]}
        >
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Text style={{ fontSize: '16px', color: '#374151' }}>
              Are you sure you want to delete this communication?
            </Text>
            <div
              style={{
                marginTop: '12px',
                fontWeight: 'bold',
                color: '#000',
                fontSize: '18px',
              }}
            >
              {itemToDelete?.tagTitle}
            </div>
            <p style={{ marginTop: '16px', color: '#6b7280' }}>
              This action cannot be undone and will remove the data permanently.
            </p>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

const mapStateToProps = ({ toolBoxAdminReducer }) => {
  const toolboxList = get(toolBoxAdminReducer, 'toolBoxAdminData', []);
  const istoolboxListLoading = get(toolBoxAdminReducer, 'isFetchtoolBoxAdminDataLoading', false);
  return {
    toolboxList,
    istoolboxListLoading,
  };
};

const mapDispatchToProps = {
  onFetchToolBoxList: fetchToolBoxList,
  onAddToolBox: addToolBox,
  onUpdateToolBox: updateToolBox,
  onDeleteToolBox: deleteToolBox,
  onDeleteToolBoxListFile: deleteToolBoxListFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolboxAdmin);
